import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap, tap } from 'rxjs/operators';
import { RankingEndpointsService } from 'src/app/api/services';
import * as fromActions from './ranklist.actions';
import { of } from 'rxjs';
import { RankListResponseWrapper } from 'src/app/api/models';

@Injectable()
export class RanklistEffects {
  loadRanklist$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromActions.loadMany),
      mergeMap(({ month, roomId, level, nameSpace }) =>
        this.api
          .getRankList({
            month: month,
            roomId: roomId,
            level: level,
            nameSpace: nameSpace,
          })
          .pipe(
            map((ranklist) => {
              return fromActions.loadManySuccess({ items: [ranklist] });
            }),
            catchError((error) => of(fromActions.loadManyFail({ error }))),
          ),
      ),
    ),
  );

  constructor(
    private actions$: Actions,
    private api: RankingEndpointsService,
  ) {}
}
